export default __webpack_public_path__ + "static/media/route4u-hive.ffbc79d8.png";